"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.channel = void 0;

var _addons = _interopRequireDefault(require("@storybook/addons"));

var _channelPostmessage = _interopRequireDefault(require("@storybook/channel-postmessage"));

var channel = (0, _channelPostmessage.default)({
  page: 'manager'
});
exports.channel = channel;

_addons.default.setChannel(channel);
//# sourceMappingURL=channel.js.map